import { AbstractControl } from '@angular/forms';

// custom validator to check that two fields match
export function NoMatch(controlName: string, matchingControlName: string) {
    return (group: AbstractControl) => {
        const control = group.get(controlName);
        const matchingControl = group.get(matchingControlName);

        if (!control || !matchingControl) {
            
            return null;
        }

        if (control.value ==='' && matchingControl.value==='' ) {
            matchingControl.setErrors(null);
            return null;
        }

        if (matchingControl.errors && !matchingControl.errors['areSame']) {
            return null;
        }

        // set error on matchingControl if validation fails
        if (control.value === matchingControl.value) {
           
            matchingControl.setErrors({ 'areSame': true });
        } else {
            matchingControl.setErrors(null);
 
        }
        return null;
    }
}